import { PosSessionsControllerFindAll$Params } from '@klubovna/api-client';
import { HelperResponseDto, PosOverallStatsDto, PosSession, PosSessionStatsDto } from '@klubovna/api-client';

export interface PosSessionsState {
  sessions: PosSession[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  params: PosSessionsControllerFindAll$Params;
  currentSession: PosSession | null;
  helpers: HelperResponseDto[];
  helpersLoading: boolean;
  overallStats: PosOverallStatsDto | null;
  selectedSessionStats: PosSessionStatsDto | null;
  loading: boolean;
  currentSessionLoading: boolean;
  statsLoading: boolean;
  error: string | null;
}

export const initialPosSessionsState: PosSessionsState = {
  sessions: [],
  total: 0,
  page: 1,
  limit: 20,
  totalPages: 0,
  params: {
    page: 1,
    limit: 20,
    sortBy: 'startsAt',
    sortOrder: 'DESC',
  },
  currentSession: null,
  helpers: [],
  helpersLoading: false,
  overallStats: null,
  selectedSessionStats: null,
  loading: false,
  currentSessionLoading: false,
  statsLoading: false,
  error: null,
};

